export enum TrendingGroupByOption {
  Phase,
  Form5 = 5,
  Form10 = 10,
  Form20 = 20
}
